module.exports = __webpack_public_path__ + "img/f2.debc020.png";